import { createReducer, on } from '@ngrx/store'
import { filter, isEqual, sumBy, uniq, map } from 'lodash-es'
import { createEntityAdapter, EntityState } from '@ngrx/entity'

import * as SegmentViewActions from './segment-view.actions'
import { ElasticSearchFilters } from 'src/services/elastic-search'
import { prepareSegmentsPayload } from './segment-view-filters.utils'
import { SegmentRow } from 'src/services/data/segments-elastic.service'

export const segmentViewsFeatureKey = 'segmentViews'

export interface SegmentViewsState extends EntityState<SegmentRow> {
  filters: Dictionary<ElasticSearchFilters>
  prevQuery: Dictionary<any>
  // segment ids lists grouped by table key
  tables: Dictionary<string[]>
  // total segments lists grouped by table key
  totals: Dictionary<Dictionary<any>>
}

const selectId = row => {
  return row.segment_id
}

export const adapter = createEntityAdapter<SegmentRow>({ selectId })

const initialState: SegmentViewsState = adapter.getInitialState({
  tables: {},
  totals: {},
  filters: {},
  prevQuery: {},
})

export const segmentViewReducer = createReducer(
  initialState,
  on(SegmentViewActions.loadSegmentViews,
    (state, action) => {
      const key = action.tableKey
      const query = prepareSegmentsPayload(action.filters, action.page)
      const prev = state.prevQuery[key] || {}

      let { tables, prevQuery } = state
      if (!isEqual(query.query, prev.query)) {
        tables = { ...tables, [key]: undefined } // drop table
        prevQuery = { ...prevQuery, [key]: query } // save query
  
      } else if (!isEqual(query.sort, prev.sort)) {
        const table = [...tables[key] || []]
        tables = { ...tables, [key]: table.fill(undefined) } // clear table
        prevQuery = { ...prevQuery, [key]: query } // save query
      }
      return { ...state, tables, totals: {}, prevQuery }
    }),
  on(SegmentViewActions.loadSegmentViewsSuccess,
    (state, action) => {
      const key = action.tableKey
      const { total, totals: totals_, segmentViews, payload: { skip } } = action
      const segmentIds = segmentViews.map(selectId)

      let table = Array.from<string>({ length: total }).fill(undefined)
      table.splice(skip, segmentIds.length, ...segmentIds) // NOTE: segmentIds.length or limit?
      const tables = { ...state.tables, [key]: table }
      const totals = { ...state.totals, [key]: totals_ }

      state = adapter.upsertMany(action.segmentViews, state)
      return { ...state, tables, totals }
    }),
  on(SegmentViewActions.loadSegmentFiltersSuccess,
    (state, action) => {
      const key = action.tableKey
      const filters = { ...state.filters, [key]: action.result }
      return { ...state, filters }
    }),
)

